import React, { FC, ReactElement } from "react";

import { classNames, } from "components/Utils";
import { DamageType, Icons, } from ".";

import "./style.scss";

type Props = {
    damage: DamageType[] | undefined;
};

export const DamageMeter:FC<Props> = (props: Props): ReactElement => {
    const { damage, } = props;

    const css = classNames([
        "w-100",
        "__damagemeter__",
    ]);

    const containerCss = classNames([
        "form-control",
        "d-flex",
        "align-items-stretch",
        "__meter__",
        damage === undefined ? "disabled" : "",
    ]);

    const content = damage ? renderSegements(damage) : [];

    return (
        <div className={css}>
            <div className={containerCss}>
                {content}
            </div>
        </div>
    );
};

const renderSegements = (damage: DamageType[]): ReactElement[] => {
    return damage.map((el, index) => {
        let css = "";
        let tooltip = "";
        let svg = Icons.NoDamage;

        switch (el) {
            case DamageType.Aggravated:
                css = "aggravated";
                tooltip= "Aggravated damage";
                svg = Icons.AggravatedDamage;
                break;

            case DamageType.Superficial:
                css = "superficial";
                tooltip= "Superficial damage";
                svg = Icons.SuperficialDamage;
                break;

            default:
                css = "none";
        }

        const segmentCss = classNames([
            "flex-fill",
            "__segement__",
            css,
        ]);

        return (
            <div className={segmentCss} title={tooltip} key={index}>
                {svg}
            </div>
        );
    });
};
